// @flow
import * as React from 'react';
import { translate } from 'react-i18next';
import styled, { withTheme } from 'styled-components';
import { PlayerDemo } from '../../../styles';
import type { StatsRadioPlayerStationInformationData, StatsRadioPlayerThemeData } from '../../../../domain/PlayerConfiguration';

const SDiv = styled.div`
  width: 90%;
  margin: auto;
`;

const Title = styled(SDiv)`
  font-size: 30px;
  padding-top: ${props => props.theme.metrics.margin}px;
`;

const Description = styled(SDiv)`
  display: block;
  margin-top: ${props => props.theme.metrics.smallMargin}px;
  font-size: 16px;
  padding-bottom: ${props => props.theme.metrics.margin}px;
`;

const LinksContainer = styled(SDiv)`
  display: block;
`;

const LinksTitle = styled.div`
  width: 100%;
  padding: ${props => props.theme.metrics.smallMargin}px 0;
  padding-left: ${props => props.theme.metrics.margin}px;
  font-size: 22px;
  line-height: 22px;
`;

const Link = styled.a`
  display: block;
  width: 100%;
  padding: 10px 0;
  padding-left: 15px;
  font-size: 20px;
  text-decoration: none;
`;

type Props = {
  data: StatsRadioPlayerStationInformationData,
  demoTheme: StatsRadioPlayerThemeData;
  colors: Object;
  theme: any;
  t: any;
}

function StationInformationsDemo(props: Props) {
  let linkKeyNumber = 0;

  return (
    <PlayerDemo
      style={{
        backgroundColor: props.demoTheme.stationInformation.backgroundColor,
        height: 'auto',
        paddingBottom: `${props.theme.metrics.margin}px`,
        color: props.demoTheme.stationInformation.textColor,
      }}
    >
      <Title>
        { props.data.name }
      </Title>
      <Description>
        { props.data.description }
      </Description>
      { props.data.links.length > 0 &&
      <LinksContainer style={{ backgroundColor: props.colors.linkBackgroundColor }}>
        <LinksTitle style={{ backgroundColor: props.colors.linkHeaderColor, color: props.colors.linkHeaderTextColor }}>
          { props.t('stationLinks')}
        </LinksTitle>
        {props.data.links.map((link) => {
          linkKeyNumber++;
          return (
            <Link
              key={link.name + `-${linkKeyNumber}`}
              style={{ color: props.colors.linkTextColor }}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
            >
              {link.name}
            </Link>
          );
        })
        }
      </LinksContainer>
    }
    </PlayerDemo>
  );
}

export default translate('radioConfiguration')(withTheme(StationInformationsDemo));



// WEBPACK FOOTER //
// ./src/statsradio/modules/radioConfiguration/components/playerConfigurationForm/statsRadioPlayer/demos/StationInformationsDemo.js